import { Layout } from 'react-admin';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import MyMenu from './menu';
import MyAppBar from './appBar';

const useStyles = makeStyles({
    Layout: {
        '& > div': {
            background: 'linear-gradient(135deg, #f5f7fa 0%, #e4eaf2 50%, #dbe6f0 100%)',
            minHeight: '100vh',
        },
        '& .MuiPaper-root > div[class^="RaSidebar-fixed-"]': { width: 55 },
        '& > div > div[class^="RaLayout-content"]': {
            background: 'linear-gradient(135deg, #f5f7fa 0%, #e4eaf2 50%, #dbe6f0 100%)',
            minHeight: 'calc(100vh - 64px)',
        },
    },
});


const   MyLayout = (props) => {
    const open = useSelector(state => state.admin.ui.sidebarOpen);
    const classes = useStyles();
    return (
        <Layout {...props} menu={MyMenu} appBar={MyAppBar} className={!open ? classes.Layout : []} />
    )
}

export default MyLayout;